<div class="mh-page">
    <div class="mh-header">
        <button type="button" class="mh-back-arrow" (click)="goBack()">
            <img src="assets/img/icons/intel-back-arrow.svg" width="12" height="18" alt="">
        </button>
        <div>
            <p class="mh-title">Histórico de mantenimiento{{data?.unit?.unit ? ' - ' + data.unit.unit : ''}}</p>
            <p class="mh-subtitle">Consulta todo el historial de servicios realizados a cada unidad</p>
        </div>
    </div>

    <div class="mh-filter-bar">
        <div class="mh-filter-group">
            <label>Unidad</label>
            <select [ngModel]="unitId" (ngModelChange)="onUnitChanged($event)">
                <option *ngFor="let u of filteredUnits" [value]="u.id">{{u.unit}}</option>
            </select>
        </div>
        <div class="mh-filter-group">
            <label>Tipo de unidad</label>
            <select [(ngModel)]="filterUnitTypeId" (ngModelChange)="onUnitTypeFilterChanged()">
                <option value="">Todos los tipos</option>
                <option *ngFor="let t of unitTypeOptions" [value]="t.id">{{t.label}}</option>
            </select>
        </div>
        <div class="mh-filter-group mh-filter-group--period">
            <label>Periodo</label>
            <app-date-range-picker
                [from]="filterFrom" [to]="filterTo"
                (fromChange)="filterFrom = $event" (toChange)="filterTo = $event"
                (rangeApplied)="applyFilters()">
            </app-date-range-picker>
        </div>
        <div class="mh-filter-group">
            <label>Tipo de mantenimiento</label>
            <select [(ngModel)]="filterCategory" (ngModelChange)="applyFilters()">
                <option value="">Todos</option>
                <option value="Correctivo">Correctivo</option>
                <option value="Preventivo">Preventivo</option>
                <option value="Llantas">Llantas</option>
                <option value="Otros">Otros</option>
            </select>
        </div>
        <div class="mh-filter-group">
            <label>Estatus</label>
            <select [(ngModel)]="filterStatus" (ngModelChange)="applyFilters()">
                <option value="">Todos</option>
                <option value="Terminado">Terminado</option>
                <option value="Pagado">Pagado</option>
            </select>
        </div>
    </div>

    <ng-container *ngIf="data">
        <div class="mh-kpi-grid">
            <app-kpi-card icon="assets/img/icons/intel-mh-kpi-gasto.svg" iconBg="#dcfce7" label="Gasto total por mantenimiento" [value]="formatCurrency(data.kpis.gasto_total.value)" [changePct]="data.kpis.gasto_total.change_pct" changeTone="bad"></app-kpi-card>
            <app-kpi-card icon="assets/img/icons/intel-mh-kpi-gastokm.svg" iconBg="#dbeafe" label="Gasto por km" [value]="data.kpis.gasto_por_km.value !== null ? formatCurrency(data.kpis.gasto_por_km.value) : '—'" [changePct]="data.kpis.gasto_por_km.change_pct" changeTone="bad"></app-kpi-card>
            <app-kpi-card icon="assets/img/icons/intel-mh-kpi-realizados.svg" iconBg="#f3e8ff" [label]="'Mantenimientos realizados'" [value]="data.kpis.realizados.value + ' Servicios'" [changePct]="data.kpis.realizados.change_pct" changeTone="good"></app-kpi-card>
        </div>

        <div class="mh-card">
            <p class="mh-card-title">Insights ejecutivos</p>
            <div class="mh-insights-grid">
                <div class="mh-insight" *ngIf="data.insights.ultimo">
                    <div class="mh-insight-icon" style="background:#dcfce7">
                        <img src="assets/img/icons/intel-mh-insight-ultimo.svg" width="20" height="20" alt="">
                    </div>
                    <div class="mh-insight-body">
                        <p class="mh-insight-label">Ultimo mantenimiento realizado</p>
                        <p class="mh-insight-name">{{data.insights.ultimo.label}}</p>
                        <div class="mh-insight-facts">
                            <span><strong>Fecha:</strong> {{formatDateLong(data.insights.ultimo.date)}}</span>
                            <span><strong>Kilometraje:</strong> {{formatKm(data.insights.ultimo.km)}}</span>
                        </div>
                        <div class="mh-insight-facts">
                            <span><strong>Costo:</strong> {{formatCurrency(data.insights.ultimo.cost)}}</span>
                            <span *ngIf="data.insights.ultimo.supplier"><strong>Proveedor:</strong> {{data.insights.ultimo.supplier}}</span>
                        </div>
                    </div>
                </div>
                <div class="mh-insight" *ngIf="data.insights.proximo; else noProximo">
                    <div class="mh-insight-icon" style="background:#fef9c2">
                        <img src="assets/img/icons/intel-mh-insight-proximo.svg" width="20" height="20" alt="">
                    </div>
                    <div class="mh-insight-body">
                        <div class="mh-insight-header">
                            <p class="mh-insight-label">Próximo mantenimiento programado</p>
                            <span class="mh-badge-proximo">Próximo</span>
                        </div>
                        <p class="mh-insight-name">A los {{formatKm(data.insights.proximo.target_km)}}</p>
                        <div class="mh-insight-facts">
                            <span *ngIf="data.insights.proximo.current_km !== null"><strong>Kilometraje actual:</strong> {{formatKm(data.insights.proximo.current_km)}}</span>
                            <span *ngIf="data.insights.proximo.remaining_km !== null"><strong>Faltan:</strong> {{formatKm(data.insights.proximo.remaining_km)}}</span>
                        </div>
                    </div>
                </div>
                <ng-template #noProximo>
                    <div class="mh-insight">
                        <div class="mh-insight-icon" style="background:#f3f4f6">
                            <img src="assets/img/icons/intel-mh-insight-proximo.svg" width="20" height="20" alt="">
                        </div>
                        <div class="mh-insight-body">
                            <p class="mh-insight-label">Próximo mantenimiento programado</p>
                            <p class="mh-insight-sub">Sin kilometraje objetivo registrado todavía</p>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>

        <div class="mh-two-col">
            <div class="mh-card">
                <p class="mh-card-title">Resumen del periodo</p>
                <app-donut-chart [slices]="data.distribution.slices" [total]="data.distribution.total"></app-donut-chart>
                <p class="mh-distribution-note">Los correctivos concentra el <strong>{{data.distribution.correctivo_pct}}%</strong> del resumen del periodo</p>
            </div>
            <div class="mh-card">
                <p class="mh-card-title">Información de la unidad</p>
                <div class="mh-unit-info">
                    <div class="mh-unit-row"><span class="mh-unit-label">Unidad:</span> <strong>{{data.unit.unit}}</strong></div>
                    <div class="mh-unit-row"><span class="mh-unit-label">Tipo:</span> <strong>{{data.unit.type || '—'}}</strong></div>
                    <div class="mh-unit-row"><span class="mh-unit-label">Placas:</span> <strong>{{data.unit.plates || '—'}}</strong></div>
                    <div class="mh-unit-row"><span class="mh-unit-label">Kilometraje actual:</span> <strong>{{formatKm(data.unit.current_km)}}</strong></div>
                    <div class="mh-unit-row"><span class="mh-unit-label">Estatus:</span> <span class="mh-status-pill" [class.mh-status-pill--terminado]="data.unit.active" [class.mh-status-pill--pendiente]="!data.unit.active">{{data.unit.active ? 'Activo' : 'Inactivo'}}</span></div>
                </div>
            </div>
        </div>

        <div class="mh-card mh-table-card">
            <p class="mh-card-title mh-card-title--padded">Histórico de mantenimiento</p>
            <div class="mh-table-scroll">
                <table class="mh-full-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Fecha</th>
                            <th>Tipo</th>
                            <th>Servicios realizados</th>
                            <th>Proveedor/taller</th>
                            <th>Costo total</th>
                            <th>Estatus</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of data.history.data; let i = index">
                            <td>{{(currentPage - 1) * perPage + i + 1}}</td>
                            <td>{{formatDate(row.date)}}</td>
                            <td>{{row.type}}</td>
                            <td class="mh-cell-ellipsis">{{row.description}}</td>
                            <td>{{row.supplier}}</td>
                            <td>{{formatCurrency(row.cost_total)}}</td>
                            <td><span class="mh-status-pill" [ngClass]="statusPillClass(row.status_tone)">{{row.status_label}}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="mh-pagination-bar" *ngIf="data.history.pagination.total > 0">
                <span>Mostrando {{(currentPage - 1) * perPage + 1}} a {{Math.min(currentPage * perPage, data.history.pagination.total)}} de {{data.history.pagination.total}} servicios</span>
                <div class="mh-pagination" *ngIf="data.history.pagination.last_page > 1">
                    <button type="button" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">‹</button>
                    <button type="button" *ngFor="let p of pageNumbers" [class.active]="p === currentPage" (click)="goToPage(p)">{{p}}</button>
                    <button type="button" [disabled]="currentPage === data.history.pagination.last_page" (click)="goToPage(currentPage + 1)">›</button>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
